import { useEffect, useState } from "react";
import paLogo from "@/assets/pa-logo.png";

/**
 * Short, elegant intro screen:
 * black screen + white logo -> white screen + black logo -> smooth fade out.
 */
export const Preloader = () => {
  /** starts light (white bg + black logo) -> dark (black bg + white logo) -> fade out */
  const [light, setLight] = useState(true);
  const [hidden, setHidden] = useState(false);
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const t1 = window.setTimeout(() => setLight(false), 650);
    const t2 = window.setTimeout(() => setHidden(true), 1650);
    const t3 = window.setTimeout(() => {
      setRemoved(true);
      document.body.style.overflow = "";
    }, 2200);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.clearTimeout(t3);
      document.body.style.overflow = "";
    };
  }, []);

  if (removed) return null;

  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 z-[10000] flex items-center justify-center"
      style={{
        backgroundColor: light ? "#FFFFFF" : "#000000",
        opacity: hidden ? 0 : 1,
        transition:
          "background-color 900ms cubic-bezier(0.2, 0.8, 0.2, 1), opacity 520ms cubic-bezier(0.2, 0.8, 0.2, 1)",
        pointerEvents: hidden ? "none" : "auto",
        willChange: "opacity, background-color",
      }}
    >
      <img
        src={paLogo}
        alt=""
        width={140}
        height={140}
        decoding="sync"
        className="w-[30vw] max-w-[140px] min-w-[90px]"
        style={{
          filter: light ? "invert(1)" : "invert(0)",
          transform: `translate3d(0,0,0) scale(${hidden ? 1.06 : light ? 1.02 : 1})`,
          transition:
            "filter 900ms cubic-bezier(0.2, 0.8, 0.2, 1), transform 1200ms cubic-bezier(0.2, 0.8, 0.2, 1)",
        }}
      />
    </div>
  );
};
